export default __webpack_public_path__ + "static/media/frontpage.9cfcd598.txt";